import React from 'react';
import { Button } from 'react-bootstrap';
import * as FileSaver from 'file-saver'
import XLSX from 'sheetjs-style';

import { FiletypeXlsx  } from 'react-bootstrap-icons';


const ExportExcel = ({excelData, fileName}) => {

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx'

    const exportToExcel = async () => {
        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = {Sheets: {'data': ws}, SheetNames: ['data']};
        const excelBuffer = XLSX.write(wb, {bookType:'xlsx', type: 'array'});
        const data = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data, fileName + fileExtension) 
    }
    return(
        <>
        <Button variant="success"
        onClick={(e) => exportToExcel(fileName)} 
        style={{cursor:"pointer", fontSiza: 14}}><FiletypeXlsx size={30}/></Button>
        </>
    )
}
export default ExportExcel
